import { Box, IconButton, Grid, Tooltip } from "@mui/material";
import MaterialTable from "material-table";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import Popup from "../../../../Base/views/Popup";
import { useState } from "react";
import { GetBonusConfigurationAction } from "../../../../../../store/Finance/PayRollTemplate/Action";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StatutoryBonus from "./StatutoryBonus";

const StatutoryBonusGrid = () => {
  const dispatch = useDispatch();
  const { bonus_configuration_data, isLoadingBonusConfiguration } = useSelector(
    (state) => state.FinanceReducer?.PayrollTemplateReducer,
  );
  const [editedRecord, setEditedRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  useEffect(() => {
    dispatch(GetBonusConfigurationAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };

  const addMode = (resetForm) => {
    resetForm();
    setEditedRecord(null);
    setOpenPopup(false);
  };

  return (
    <Grid container spacing={2} style={{ padding: "10px 0px" }}>
      <Grid item xs={12} md={12}>
        <Box>
          <MaterialTable
            isLoading={isLoadingBonusConfiguration}
            columns={[
              {
                title: (
                  <span>
                    Bonus Percentage&nbsp;
                    <Tooltip
                      title="Percentage of eligible salary paid as bonus."
                      placement="top"
                      arrow
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        color="action"
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </span>
                ),
                field: "bonus_percentage",
                cellStyle: { padding: "10px 10px 10px 13px" },
              },
              {
                title: (
                  <span>
                    Payout Frequency&nbsp;
                    <Tooltip
                      title="Monthly pays bonus every month."
                    //   title="Monthly pays bonus every month; Yearly pays it once in the selected month."
                      placement="top"
                      arrow
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        color="action"
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </span>
                ),
                field: "ph_allowance_earning_components",
                cellStyle: { padding: "10px 10px 10px 13px" },
                render: (rowData) => rowData?.bonus_credit_type_monthly ? "Monthly" : "Yearly"
              },
              {
                title: (
                  <span>
                    Payout Month&nbsp;
                    <Tooltip
                      title={
                        "Bonus will be paid in the selected month once a year"
                      }
                      placement="top"
                      arrow
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        color="action"
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </span>
                ),
                field: "",
                cellStyle: { padding: "10px 10px 10px 13px" },
                hidden: (rowData) => rowData?.bonus_credit_type_monthly
              },
            ]}
            data={bonus_configuration_data}
            options={{
              maxBodyHeight: 220,
              rowStyle: { fontSize: "13px" },
              headerStyle: { padding: "5px 30px 5px 10px", fontWeight: "bold" },
              sorting: false,
              search: false,
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "standard",
              filtering: false,
              paging: false,
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              addRowPosition: "first",
            }}
            onSelectionChange={(rows) => {
              return rows.filter((row) => row?.status === "Submitted");
            }}
            actions={[
              {
                icon: () => (
                  <IconButton sx={{ padding: "0px" }}>
                    <EditIcon />
                  </IconButton>
                ),
                tooltip: "Edit",
                onClick: (_event, rowData) => {
                  handleEdit(rowData);
                },
              },
              // {
              //     icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
              //     tooltip: "Delete",
              //     onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
              // },
            ]}
            title=""
            components={{
              Toolbar: (props) => (
                <div
                  style={{
                    minHeight: "10px",
                    padding: "10px 25px",
                    borderRadius: "5px 5px 0px 0px",
                  }}
                >
                  {props.title}
                </div>
              ),
            }}
          />
          <Popup
            fullWidth={true}
            maxWidth="sm"
            title={editedRecord ? "Edit" : "Add"}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <StatutoryBonus
              editedRecord={editedRecord}
              addMode={addMode}
              setOpenPopup={setOpenPopup}
            />
          </Popup>
        </Box>
      </Grid>
    </Grid>
  );
};

export default StatutoryBonusGrid;
